<template>
    <div class="top_menu">    
        <div @click="()=> $router.push('/')" class="top_buttons"> ⬅️ Назад </div>
        <div @click="
        this.fetchUserForm();
        this.$router.push(`/form/${$route.params.id}`);" 
        class="top_buttons"> Анкета 📝 </div>
    </div>
    <div class="info_container">
        <p>🙋 {{ this.GetUser[0].user_fio }}</p>
        <div class="id_line">
            <p>🆔 <div id="text_to_copy">{{ this.GetUser[0].user_id }}</div></p> <img @click="copyId" class="copy_icon" src="@/assets/copy_icon.png">
        </div>
    </div>


    <textarea class="notion" placeholder="Заметка..." name="" id="" rows="5"></textarea>
</template>

<script>
import {mapGetters, mapState, mapActions, mapMutations} from 'vuex';
import Clipboard from 'clipboard';

    export default {
        layout: "ws",
        methods: {
        ...mapMutations({
            setUserId: 'setUserId',
        }),
        ...mapActions({
            fetchUsers: 'fetchUsers',
            fetchUserForm: 'fetchUserForm'
        }),
        ...mapGetters({

        }),
        copyId() {
            var range = document.createRange();
            range.selectNode(document.querySelector("#text_to_copy"));
             window.getSelection().removeAllRanges();
             window.getSelection().addRange(range);
             document.execCommand("copy");
             window.getSelection().removeAllRanges();
        }
    },
    mounted() {
        this.fetchUsers()
        },
     computed: {
        ...mapState({
            users: state => state.users,
            user_id: state => state.user_id
        }),
        ...mapGetters({
            GetUser: "GetUser"
        })
     },



}
</script>

<style scoped>

.top_buttons {
    margin: 10px;
    padding: 5px;
}
.top_menu{
    display: flex;
    justify-content: space-between;
}
.info_container {
    padding: 30px;
}
.notion{
    position: absolute;
    bottom: 0px;
    left: 0;
    width: 100%;
    border: none;
    background-color: rgb(182, 195, 247);
    padding: 30px;
}

.copy_icon{
    max-width: 20px;
    margin: 10px 15px;
}

.id_line{
    display: flex;
}
.id_line p{
    display: flex;
    align-items: center;
    margin-bottom: 0;
}
</style>